import fetch from "auth/FetchInterceptor";

const authModuleService = {};

authModuleService.get = function (params = {}) {
	return fetch({
		url: "/v1/rest/auth-action",
		method: "get",
		params,
	});
};

export default authModuleService;
